<template>
  <div class="switch-button-control">
    <div
      class="switch-button"
      :class="{
        enabled: selected,
        disabled,
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled,
      }"
      :style="{'--color': color}"
      @click="toggle"
    >
      <div class="button" />
    </div>
  </div>
</template>
<script>

export default {
  name: 'InputSwitch',
  props: {
    color: {
      type: String,
      required: false,
      default: '#0064e3',
    },
    active: {
      type: Boolean,
      required: true,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  emits: ['update'],
  data() {
    return {
      selected: false,
    };
  },
  watch: {
    active: {
      handler(value) {
        this.selected = value;
      },
    },
  },
  mounted() {
    this.selected = this.active;
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.selected = !this.selected;
        this.$emit('update', this.selected);
      }
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.switch-button-control {
  display: flex;
  flex-direction: row;
}
.switch-button-control .switch-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 32px;
  width: 56px;
  border: 2px solid#BFC9D6;
  background: #EDF1F8;
  border-radius: 2rem;
  transition: all 0.3s ease-in-out;
}
.switch-button-control .switch-button.enabled {
  background: var(--color);
  border-color: #0054BF;
  box-shadow: none;
}
.switch-button-control .switch-button.disabled {
  opacity: 0.3;
  border-color: #D6DEE8;
  background: #F5F7FA;
  box-shadow: none;
}
.switch-button-control .switch-button.enabled.disabled {
  opacity: 0.4;
  background: var(--color);
  border-color: #0054BF;
}
.switch-button-control .switch-button .button {
  background:white;
  display: flex;
  height: 26px;
  width: 26px;
  border: 0px;
  margin-left: 2px;
  border-radius: 56px;
  transition: all 0.3s ease-in-out;
}

.switch-button-control .switch-button.enabled .button {
  background:white;
  margin: 0;
  border: 1px solid var(--color);
  transform: translateX(24px);
}
.switch-button-control .switch-button.disabled .button {
  border: 1px solid #D6DEE8;
}
.switch-button-control .switch-button.enabled.disabled .button {
  border-color: var(--color);
}
</style>
